/** Rango de fechas del periodo fiscal SAT (año + mes o año completo). */

export function monthRangeFromYm(ym) {
  const [y, m] = String(ym || "").split("-").map(Number);
  if (!y || !m) return { from: "", to: "" };
  const yy = String(y).padStart(4, "0");
  const mm = String(m).padStart(2, "0");
  const lastDay = new Date(y, m, 0).getDate();
  return {
    from: `${yy}-${mm}-01`,
    to: `${yy}-${mm}-${String(lastDay).padStart(2, "0")}`,
  };
}

export function satPeriodRange(year, satMes) {
  if (satMes === "all") {
    return { from: `${year}-01-01`, to: `${year}-12-31` };
  }
  return monthRangeFromYm(`${year}-${satMes}`);
}
